/* eslint-disable react/prefer-stateless-function */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import styles from './styles';
import {
  BANK_TRANSFER,
  VOUCHER,
} from '../../../../config/constants';
import PaymentTypeLabel from '../../../../components/PaymentTypeLabel/PaymentTypeLabel';


class Voucher extends React.Component {
  renderVoucherInfo = (classes, price) => {
    const subText = `Why not use your credit to purchase your next read, 
      choose from over 8 million book titles with our partner.`;
    const link1 = 'www.awesome';
    const link2 = 'books.com';
    const voucherPrice = `£${(price).toFixed(2)} `;
    const textForVoucherPrice = ' to spend site wide';

    return (
      <div className={classes.infoContainer}>
        <a href={'https://www.awesomebooks.com'} className={classes.linkText}>
          <span className={classes.linkText1}>{link1}</span>
          <span>{link2}</span>
        </a>
        <span className={classes.subText}>{subText}</span>
        <div className={classes.voucherPriceContainer}>
          <span
            className={classNames(classes.paymentMethodText,
              classes.paymentMethodTextNoMargin, classes.voucherPriceText)}
          >
            {voucherPrice}
          </span>
          <span className={classes.bottomText}>{textForVoucherPrice}</span>
        </div>
      </div>
    );
  }

  render() {
    const {
      text,
      price,
      classes,
      selectedPaymentType,
      setPaymentType,
    } = this.props;

    return (
      <PaymentTypeLabel
        type={VOUCHER}
        text={text}
        price={price}
        showEditButton={false}
        selectedPaymentType={selectedPaymentType}
        setPaymentType={setPaymentType}
        renderPaymentTypeInfo={this.renderVoucherInfo(classes, price)}
      />
    );
  }
}

Voucher.propTypes = {
  classes: PropTypes.object,
  price: PropTypes.number,
  text: PropTypes.string,
  selectedPaymentType: PropTypes.number,
  setPaymentType: PropTypes.func,
};

Voucher.defaultProps = {
  classes: {},
  price: 0,
  text: '',
  selectedPaymentType: BANK_TRANSFER,
  setPaymentType: () => { },
};

export default withStyles(styles)(Voucher);
